<template>
  <div id="app">
    <router-view></router-view>
    <FixedBackground></FixedBackground>
    <ScrollToTop></ScrollToTop>
    <FooterButtons class="d-md-none"></FooterButtons>
    <Footer></Footer>
  </div>
</template>

<script>
import FixedBackground from "./components/FixedBackground";
import ScrollToTop from "./components/ScrollToTop";
import FooterButtons from "./components/FooterButtons";
import Footer from "./components/Footer";
export default {
  name: 'App',
  components: {
    FixedBackground,
    ScrollToTop,
    FooterButtons,
    Footer
  },
  mounted() {
    window.onscroll = function (){
      const pointerList = document.querySelector('.partners-list');
      if (pointerList &&pointerList.classList.contains('d-inline-block')){
        pointerList.classList.remove('d-inline-block');
        document.querySelector('.map-table-none').style.display = 'none'
        pointerList.style.left = 'unset'
        pointerList.style.top = 'unset'
      }

      //****** scroll to top */
      let scrollToTop=document.getElementById('scroll-t-top');
      if (scrollToTop){
        if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
          scrollToTop.style.bottom="30px";
        }
        else if(document.body.scrollTop <= 500 || document.documentElement.scrollTop <= 500){
          scrollToTop.style.bottom="-43px";
        }
      }


    }

    


  }
}
</script>

<style>
#app{
  /*background: white;*/
}
.v-dialog-container .v-dialog-header {
    color: #454d5d;
    padding: 16px;
    display: flex !important;
    justify-content: space-between !important;
    flex-direction: row-reverse !important;
}
</style>
